import React, { useState, useEffect } from "react";
import Logo from '../../assets/LOGO.png';
import "./index.css";
import { FaBars, FaTools, FaHistory, FaCalendarAlt } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdExit } from "react-icons/io";
import { useNavigate } from 'react-router';
import secureLocalStorage from "react-secure-storage";
import { isPortalAdminUser } from "../../utils/portalAccess";

const Header = () => {

  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const [acp, setAcp] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {

    const logoFromStorage = secureLocalStorage.getItem("lg");

    const image = new Image();
    image.src = logoFromStorage;

    image.onload = () => setLogo(logoFromStorage);
    image.onerror = () => setLogo(null);

    const companyStorage = secureLocalStorage.getItem('ab');
    setCompany(companyStorage?.trim());
    const acpStorage = secureLocalStorage.getItem('acp');
    setAcp(acpStorage?.trim());

  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogoff = () => {
    secureLocalStorage.removeItem('https');
    secureLocalStorage.removeItem('paramsEntidade');
    secureLocalStorage.removeItem('paramsQrcode');
    secureLocalStorage.removeItem('tpcm');
    secureLocalStorage.removeItem('acp');
    secureLocalStorage.removeItem('n');
    secureLocalStorage.removeItem('iag');
    secureLocalStorage.removeItem('aua');

    navigate('/login');
  };

  const chamado = () => {
    navigate('/task');
  };

  const historico = () => {
    navigate('/history');
  };

  const direcionamento = () => {
    navigate('/assignment');
  };

  const calendario = () => {
    navigate('/calendar');
  };

  return (
    <header className="chamados-header">
      <img src={logo || Logo} alt="Mobcode Logo" className="chamados-logo" />

      <nav className={`chamados-menu ${menuOpen ? "active" : ""}`}>

        {/* 🔥 MOSTRA SOMENTE PARA ADMIN */}
        {isPortalAdminUser(acp, company) && (
          <>
            <a onClick={direcionamento} className='menu-cursor'>
              <FaTools className="menu-icon-left" /> DIRECIONAMENTO
            </a>
            <a onClick={calendario} className='menu-cursor'>
              <FaCalendarAlt className="menu-icon-left" /> CALENDÁRIO
            </a>
          </>
        )}

        <a onClick={chamado} className='menu-cursor'>
          <FaTools className="menu-icon-left" /> CHAMADOS
        </a>

        <a onClick={historico} className='menu-cursor'>
          <FaHistory className="menu-icon-left" /> HISTÓRICO
        </a>

        <a onClick={handleLogoff} className='menu-cursor'>
          <IoMdExit className="menu-icon-left" /> SAIR
        </a>

      </nav>

      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? <AiOutlineClose /> : <FaBars />}
      </div>
    </header>
  );
};

export default Header;